import React from 'react';
import InlineMessage, {
  InlineMessageActions,
  InlineMessageBody,
  InlineMessageHeadingLevel,
  InlineMessageLinkLabel
} from '@ingka/inline-message';

import '@ingka/svg-icon/dist/style.css';
import '@ingka/button/dist/style.css';
import '@ingka/hyperlink-shared/dist/style.css';
import '@ingka/inline-message/dist/style.css';
import '@ingka/focus/dist/style.css';

export enum InlineMessageVariantEnum {
  INFORMATIVE = 'informative',
  POSITIVE = 'positive',
  CAUTIONARY = 'cautionary',
  NEGATIVE = 'negative'
}

type Props = {
  ssrIcon?: (...args: any[]) => any;
  labelCloseButton?: string;
  title?: string;
  body?: InlineMessageBody;
  variant?: InlineMessageVariantEnum;
  subtle?: boolean;
  dismissable?: boolean;
  onClose?: () => void;
  collapseWhenClosed?: boolean;
  headingLevel?: InlineMessageHeadingLevel;
  actions?: InlineMessageActions[];
  link?: string;
  newWindow?: boolean;
  linkLabel?: InlineMessageLinkLabel;
  dataTestId?: string;
};

const SkapaInlineMessage = ({
  ssrIcon,
  labelCloseButton,
  title,
  body,
  variant,
  subtle,
  dismissable,
  onClose,
  collapseWhenClosed,
  headingLevel,
  actions,
  link,
  newWindow,
  linkLabel,
  dataTestId
}: Props) => {
  return (
    <InlineMessage
      data-testid={dataTestId}
      title={title ? title : undefined}
      body={body ? body : undefined}
      labelCloseButton={labelCloseButton ? labelCloseButton : undefined}
      variant={variant}
      subtle={subtle}
      onDismissClick={onClose}
      dismissable={dismissable}
      collapseWhenClosed={collapseWhenClosed}
      ssrIcon={ssrIcon}
      headingLevel={headingLevel}
      actions={actions}
      link={link}
      newWindow={newWindow}
      linkLabel={linkLabel}
    />
  );
};

export default SkapaInlineMessage;
